import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { BlogAudience } from "@/gql/graphql";

export const blogAudienceLabels: Record<BlogAudience, string> = {
  [BlogAudience.Customer]: "Customer",
  [BlogAudience.Supplier]: "Supplier",
};

export function BlogAudienceInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  return (
    <SelectInput
      description="Supplier posts are left off /blog and shown on the vehicle relocation services page"
      {...props}
      options={[
        {
          label: "Audience",
          options: Object.values(BlogAudience).map((audience) => ({
            value: audience,
            label: blogAudienceLabels[audience],
          })),
        },
      ]}
    />
  );
}
